import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
const { connect } = require('react-redux');
import { reduxForm, Field, getFormSyncErrors } from 'redux-form';
import { Button, ErrorSummary, WhiteButton } from 'components';
import { PortalPageSection, ButtonsSection } from 'components/PortalStructure';
import { IStore } from 'redux/IStore';
import { required, maxLength } from 'helpers/validationattributes';
import { PortalSelectMenu, PortalInputField, PortalTextareaField, PortalSwitchField } from 'components/FormControls';
import { getCategoryDomainValues, getColorDomainValues } from 'modules/domainvalues';
import { IDomainValuesAction } from 'models/domainvalues/domainvalues';
import { ICategoryDomainValue, IDomainValue, ICropImageObject } from 'models/common';
import { IModalAction } from 'models/modal';
import { IWardrobeItem } from 'models/wardrobe/wardrobeitem';
import { IManageWardrobeItem, IManageWardrobeItemAction } from 'models/wardrobe/managewardrobeitem';
import {
	clearManageWardrobeItemFormData,
	requestFailure,
	cropAndSaveWardrobeItemImage,
	clearWardrobeItemFormError,
	submitUpdateWardrobeItem,
	getWardrobeItem,
	setCategoryDropdownsValues,
} from 'redux/modules/wardrobe/managewardrobeitem';
import { Modal } from 'components';
import { imgSrcAttributes, onCloseModalForm } from 'helpers/common';

require('../CreateWardrobeItem/style.css');
require('./style.css');

interface IProps {
	initialValues: IWardrobeItem;
	manageWardrobeItem: IManageWardrobeItem;
	currentFormValues: IWardrobeItem;
	id?: string;

	dispatch?: any;
	location: any;
	categoryDomainValues: ICategoryDomainValue[];
	colorDomainValues: IDomainValue[];

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	submitFailed: boolean;
	handleSubmit: any;
	formErrors?: any;
	submit: (formName: string) => void;
	change: (field: string, value: any) => void;

	/* functions props */
	getWardrobeItem?: (id: string) => IManageWardrobeItemAction;
	submitUpdateWardrobeItem: (wardrobeItem: IWardrobeItem) => IManageWardrobeItemAction;
	t?: (key: string, object?: any) => string;
	getCategoryDomainValues?: () => IDomainValuesAction;
	getColorDomainValues?: () => IDomainValuesAction;
	clearFormData?: () => IManageWardrobeItemAction;
	clearWardrobeItemFormError?: () => IManageWardrobeItemAction;
	requestFailure: (error: any) => IManageWardrobeItemAction;
	showModal: (modalType: string, modalProps: any) => IModalAction;
	closeModal: () => IModalAction;
	cropAndSaveWardrobeItemImage: (image: ICropImageObject, formName: string) => void;
	setCategoryDropdownsValues?: () => IManageWardrobeItemAction;
}

const maxLength255 = maxLength(255);
const maxLength4000 = maxLength(4000);

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EditWardrobeItemForm extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.mapErrorKeyToMessage = this.mapErrorKeyToMessage.bind(this);
		this.onFirstCategoryDropdownChange = this.onFirstCategoryDropdownChange.bind(this);
		this.onSecondCategoryDropdownChange = this.onSecondCategoryDropdownChange.bind(this);
		this.onThirdCategoryDropdownChange = this.onThirdCategoryDropdownChange.bind(this);
		this.onUploadPhotoClick = this.onUploadPhotoClick.bind(this);
		this.onSaveImage = this.onSaveImage.bind(this);
		this.onDeleteImageClick = this.onDeleteImageClick.bind(this);
		this.onCloseModalForm = this.onCloseModalForm.bind(this);
	}

	public componentDidMount() {
		this.props.getWardrobeItem(this.props.id);
		this.props.getCategoryDomainValues();
		this.props.getColorDomainValues();
	}

	public componentDidUpdate() {
		if (this.props.manageWardrobeItem.wardrobeItem && this.props.categoryDomainValues) {
			if (
				this.props.manageWardrobeItem.wardrobeItem.categoryKey &&
				!this.props.manageWardrobeItem.wardrobeItem.firstDropdownCategoryKey &&
				!this.props.manageWardrobeItem.wardrobeItem.secondDropdownCategoryKey &&
				!this.props.manageWardrobeItem.wardrobeItem.thirdDropdownCategoryKey &&
				!this.props.manageWardrobeItem.wardrobeItem.fourthDropdownCategoryKey
			) {
				this.props.setCategoryDropdownsValues();
			}
		}
	}

	public componentWillUnmount() {
		this.props.clearFormData();
	}

	public onSubmit(form: IWardrobeItem) {
		form.categoryKey = null;

		if (form.fourthDropdownCategoryKey) {
			form.categoryKey = form.fourthDropdownCategoryKey;
		} else if (form.thirdDropdownCategoryKey) {
			form.categoryKey = form.thirdDropdownCategoryKey;
		} else if (form.secondDropdownCategoryKey) {
			form.categoryKey = form.secondDropdownCategoryKey;
		} else if (form.firstDropdownCategoryKey) {
			form.categoryKey = form.firstDropdownCategoryKey;
		}

		if (form.images) {
			form.images = form.images.filter((x) => x.id && x.href);
		}

		this.props.submitUpdateWardrobeItem(form);
	}

	private onCloseModalForm() {
		onCloseModalForm(this.props.dirty, this.props.showModal, this.props.closeModal, this.props.t);
	}

	private mapErrorKeyToMessage(key: string, t: (key: string) => string) {
		switch (key) {
			case 'name':
				return t('Wardrobe_EditWardrobeItem_Label_Title');

			case 'description':
				return t('Wardrobe_EditWardrobeItem_Label_Description');

			case 'firstDropdownCategoryKey':
				return t('Wardrobe_EditWardrobeItem_Label_Category');

			case 'secondDropdownCategoryKey':
				return t('Wardrobe_EditWardrobeItem_Label_Category');

			default:
				return key;
		}
	}

	private onFirstCategoryDropdownChange() {
		this.props.change('secondDropdownCategoryKey', null);
		this.props.change('thirdDropdownCategoryKey', null);
		this.props.change('fourthDropdownCategoryKey', null);
	}

	private onSecondCategoryDropdownChange() {
		this.props.change('thirdDropdownCategoryKey', null);
		this.props.change('fourthDropdownCategoryKey', null);
	}

	private onThirdCategoryDropdownChange() {
		this.props.change('fourthDropdownCategoryKey', null);
	}

	private onUploadPhotoClick() {
		this.props.showModal('CropImageModal', {
			closeModal: this.props.closeModal,
			saveImage: this.onSaveImage,
			modalTitle: this.props.t('Wardrobe_EditWardrobeItem_Label_EditWardrobeItemPhoto'),
			cropOptions: {
				...c.DEFAULT_CROP_OPTIONS,
				aspectRatio: 515 / 667,
			},
		});
	}

	private onSaveImage(image: ICropImageObject) {
		this.props.cropAndSaveWardrobeItemImage(image, c.FORM_NAME_EDIT_WARDROBEITEM);
	}

	private onDeleteImageClick() {
		this.props.change('images', []);
	}

	public render() {
		const {
			pristine,
			submitting,
			handleSubmit,
			t,
			currentFormValues,
			formErrors,
			submitFailed,
			location,
			categoryDomainValues,
			colorDomainValues,
		} = this.props;
		const { error, message } = this.props.manageWardrobeItem;

		const errorSummaryProps = {
			formErrors,
			submitFailed,
			error,
			message,
			location,
			mapErrorKeyToMessage: this.mapErrorKeyToMessage,
		};

		let firstDropdownCategories = [];
		let secondDropdownCategories = [];
		let thirdDropdownCategories = [];
		let fourthDropdownCategories = [];
		if (categoryDomainValues) {
			firstDropdownCategories = categoryDomainValues
				.filter((x) => !x.parentKey)
				.map((category: ICategoryDomainValue) => {
					return {
						key: category.key,
						value: category.value,
					};
				});

			if (currentFormValues && currentFormValues.firstDropdownCategoryKey) {
				secondDropdownCategories = categoryDomainValues
					.filter((x) => x.parentKey === currentFormValues.firstDropdownCategoryKey)
					.map((category: ICategoryDomainValue) => {
						return {
							key: category.key,
							value: category.value,
						};
					});
			}

			if (currentFormValues && currentFormValues.secondDropdownCategoryKey) {
				thirdDropdownCategories = categoryDomainValues
					.filter((x) => x.parentKey === currentFormValues.secondDropdownCategoryKey)
					.map((category: ICategoryDomainValue) => {
						return {
							key: category.key,
							value: category.value,
						};
					});
			}

			if (currentFormValues && currentFormValues.thirdDropdownCategoryKey) {
				fourthDropdownCategories = categoryDomainValues
					.filter((x) => x.parentKey === currentFormValues.thirdDropdownCategoryKey)
					.map((category: ICategoryDomainValue) => {
						return {
							key: category.key,
							value: category.value,
						};
					});
			}
		}

		let colors = [];
		if (colorDomainValues) {
			colors = colorDomainValues.map((color: IDomainValue) => {
				return {
					key: color.key,
					value: t(`DV_Colors_${color.key}`),
				};
			});
		}

		return (
			<div className="createWardrobeItem">
				<Modal
					title={t('Wardrobe_EditWardrobeItem_Title')}
					closeModal={this.onCloseModalForm}
					showHeaderCloseButton={true}
				>
					<div className="editWardrobeItemWrapper">
						<form onSubmit={handleSubmit(this.onSubmit)}>
							<div className="profileError">
								<ErrorSummary {...errorSummaryProps} />
							</div>
							<PortalPageSection>
								<div className="row">
									<div className="col-md-6">
										<div className="row">
											<div className="col-md-12 leftImgBlock">
												<label className="imgTitle">Images</label>
												<div
													className="imageDropZone"
													onClick={
														currentFormValues && currentFormValues.images && currentFormValues.images.length === 1
															? () => false
															: this.onUploadPhotoClick
													}
												>
													{currentFormValues && currentFormValues.images && currentFormValues.images.length === 1 ? (
														<div>
															<div className="itemCardButtons">
																<button type="button" onClick={this.onUploadPhotoClick}>
																	<img src={require('containers/Html/icons/actionIcons/edit.svg')} />
																</button>
																<button type="button" onClick={this.onDeleteImageClick}>
																	<img src={require('containers/Html/icons/actionIcons/remove.svg')} />
																</button>
															</div>
															<div>
																<img
																	{...imgSrcAttributes(currentFormValues.images[0].href)}
																	className="imageUploadedDropZone"
																/>
															</div>
														</div>
													) : (
														<div className="noImageZone">
															<img src={require('containers/Html/images/upload-image.png')} />
															<div>
																<div>
																	<label>{t('Wardrobe_EditWardrobeItem_Label_UploadDescription')}</label>
																</div>
																<div>
																	<label>{t('Wardrobe_EditWardrobeItem_Label_ImageDescription')}</label>
																</div>
															</div>
														</div>
													)}
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-6 rightBlock">
										<div className="row">
											<div className="col-md-12">
												<Field
													name="name"
													component={PortalInputField}
													type="text"
													label={t('Wardrobe_EditWardrobeItem_Label_Title')}
													validate={[required, maxLength255]}
												/>
											</div>
										</div>

										<div className="row">
											<div className="col-md-12">
												<Field
													name="firstDropdownCategoryKey"
													component={PortalSelectMenu}
													items={firstDropdownCategories}
													label={t('Wardrobe_EditWardrobeItem_Label_Category')}
													onChangeAction={this.onFirstCategoryDropdownChange}
													isRequired={true}
													validate={[required]}
												/>
											</div>
										</div>

										{currentFormValues &&
										currentFormValues.firstDropdownCategoryKey &&
										secondDropdownCategories.length > 0 ? (
											<div className="row">
												<div className="col-md-12">
													<Field
														name="secondDropdownCategoryKey"
														component={PortalSelectMenu}
														items={secondDropdownCategories}
														onChangeAction={this.onSecondCategoryDropdownChange}
														isRequired={true}
														validate={[required]}
													/>
												</div>
											</div>
										) : null}
										{currentFormValues &&
										currentFormValues.secondDropdownCategoryKey &&
										thirdDropdownCategories.length > 0 ? (
											<div className="row">
												<div className="col-md-12">
													<Field
														name="thirdDropdownCategoryKey"
														component={PortalSelectMenu}
														items={thirdDropdownCategories}
													/>
												</div>
											</div>
										) : null}
										{currentFormValues &&
										currentFormValues.thirdDropdownCategoryKey &&
										fourthDropdownCategories.length > 0 ? (
											<div className="row">
												<div className="col-md-12">
													<Field
														name="fourthDropdownCategoryKey"
														component={PortalSelectMenu}
														items={fourthDropdownCategories}
													/>
												</div>
											</div>
										) : null}

										<div className="row">
											<div className="col-md-12">
												<Field
													name="description"
													component={PortalTextareaField}
													type="text"
													label={t('Wardrobe_EditWardrobeItem_Label_Description')}
													validate={[maxLength4000]}
												/>
											</div>
										</div>

										<div className="row">
											<div className="col-md-12">
												<Field
													name="colorKey"
													component={PortalSelectMenu}
													items={colors}
													isRequired={false}
													label={t('Shop_ManageShop_Products_CreateProduct_Label_Color')}
												/>
											</div>
										</div>

										<div className="row">
											<div className="col-md-12">
												<Field
													name="published"
													component={PortalSwitchField}
													type="checkbox"
													label={t('Wardrobe_EditWardrobeItem_Label_IsPublic')}
												/>
											</div>
										</div>
									</div>
								</div>
							</PortalPageSection>
							<ButtonsSection>
								<div className="row">
									<div className="col-sm-6">
										<div className="floatLeft contentLeft">
											<WhiteButton onClick={this.onUploadPhotoClick}>
												{t('Wardrobe_EditWardrobeItem_Button_UploadPhoto')}
											</WhiteButton>
											<div className="clear" />
										</div>
										<div className="clear" />
									</div>
									<div className="col-sm-6">
										<div className="floatRight">
											<WhiteButton onClick={this.onCloseModalForm}>{t('BSPortal_Common_Cancel')}</WhiteButton>
											<Button type="submit" disabled={pristine || submitting}>
												{t('BSPortal_Common_Save')}
											</Button>
											<div className="clear" />
										</div>
										<div className="clear" />
									</div>
								</div>
							</ButtonsSection>
						</form>
					</div>
				</Modal>
			</div>
		);
	}
}

function mapStateToProps(state: IStore) {
	const manageWardrobeItem: IManageWardrobeItem = state.manageWardrobeItem;

	let currentFormValues: IWardrobeItem = null;
	if (state.form[c.FORM_NAME_EDIT_WARDROBEITEM] && state.form[c.FORM_NAME_EDIT_WARDROBEITEM].values) {
		currentFormValues = state.form[c.FORM_NAME_EDIT_WARDROBEITEM].values;
	} else {
		currentFormValues = manageWardrobeItem.wardrobeItem;
	}

	if (
		manageWardrobeItem.wardrobeItem &&
		currentFormValues &&
		!currentFormValues.id &&
		manageWardrobeItem.wardrobeItem.id
	) {
		currentFormValues.id = manageWardrobeItem.wardrobeItem.id;
	}

	return {
		manageWardrobeItem,
		initialValues: manageWardrobeItem.wardrobeItem,
		currentFormValues,
		categoryDomainValues: state.domainValues.categories,
		colorDomainValues: state.domainValues.colors,
		formErrors: getFormSyncErrors(c.FORM_NAME_EDIT_WARDROBEITEM)(state),
	};
}

let EditWardrobeItem = reduxForm(
	{
		form: c.FORM_NAME_EDIT_WARDROBEITEM,
		enableReinitialize: true,
	},
	mapStateToProps,
)(EditWardrobeItemForm);

EditWardrobeItem = connect(mapStateToProps, (dispatch) => ({
	getWardrobeItem: (id: string) => dispatch(getWardrobeItem(id)),
	submitUpdateWardrobeItem: (wardrobeItem: IWardrobeItem) => dispatch(submitUpdateWardrobeItem(wardrobeItem)),
	getCategoryDomainValues: () => dispatch(getCategoryDomainValues()),
	getColorDomainValues: () => dispatch(getColorDomainValues()),
	clearFormData: () => dispatch(clearManageWardrobeItemFormData()),
	requestFailure: (error) => dispatch(requestFailure(error)),
	clearWardrobeItemFormError: () => dispatch(clearWardrobeItemFormError()),
	cropAndSaveWardrobeItemImage: (image: ICropImageObject, formName: string) =>
		dispatch(cropAndSaveWardrobeItemImage(image, formName)),
	setCategoryDropdownsValues: () => dispatch(setCategoryDropdownsValues()),
}))(EditWardrobeItem);

export { EditWardrobeItem };
